import { render, staticRenderFns } from "./JifenGiveItem.vue?vue&type=template&id=0d729b12&scoped=true"
import script from "./JifenGiveItem.vue?vue&type=script&lang=js"
export * from "./JifenGiveItem.vue?vue&type=script&lang=js"
import style0 from "./JifenGiveItem.vue?vue&type=style&index=0&id=0d729b12&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d729b12",
  null
  
)

export default component.exports